import config from 'config'
import { useDownload } from 'hooks/useDownload'
import usePolling from 'hooks/usePolling'
import { downloadUrl } from 'utils/download'

/** Poll các download đang chờ: khi file sẵn sàng thì tải về, lỗi thì đánh dấu error. */
const ProgressDownload = () => {
  const { tasks, updateTaskById } = useDownload()
  const hasPending = tasks.some((t) => t.status === 'pending')

  const poll = async () => {
    for (const task of tasks.filter((t) => t.status === 'pending')) {
      try {
        const res = await fetch(task.url)
        if (res.ok) {
          downloadUrl(task.url, task.name)
          updateTaskById({ id: task.id, status: 'done' })
        } else if (res.status !== 404) {
          updateTaskById({ id: task.id, status: 'error' })
        }
      } catch {
        // Lỗi mạng / CORS: không để task treo ở 'pending' mà không có phản hồi
        updateTaskById({ id: task.id, status: 'error' })
      }
    }
  }

  usePolling(poll, config.timeInterval, { enabled: hasPending })

  return null
}

export default ProgressDownload
